<template>
    <div class="tool-result-message">
        <simple-svg v-if="msg.content.success !== false" :src="CheckIcon" width="16" height="16"
            custom-class-name="icon-blue" />
        <simple-svg v-else :src="CloseMd" width="16" height="16"
            custom-class-name="icon-red" />

        <div class="tool-result-message__body">
            <p>{{ msg.content.message }}</p>

            <pre v-if="msg.content.data != null" class="json-block" v-html="highlighted"></pre>

            <HoverBar :date="msg.created_at || msg.content.created_at" :message-id="msg.id" />
        </div>
    </div>
</template>

<script setup>
import { computed, defineProps } from 'vue';
import CheckIcon from '@/assets/icons/Check.svg';
import CloseMd from '@/assets/icons/Close_MD.svg';
import HoverBar from '../ui/HoverBar.vue';

const props = defineProps({
    msg: { type: Object, required: true },
});

function highlightJson(json) {
    const str = JSON.stringify(json, null, 2);
    return str.replace(
        /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g,
        (match) => {
            if (/^"/.test(match)) {
                if (/:$/.test(match)) {
                    return `<span class="json-key">${match}</span>`;
                }
                return `<span class="json-string">${match}</span>`;
            }
            if (/true|false/.test(match)) return `<span class="json-bool">${match}</span>`;
            if (/null/.test(match)) return `<span class="json-null">${match}</span>`;
            return `<span class="json-number">${match}</span>`;
        }
    );
}

const highlighted = computed(() => highlightJson(props.msg.content.data));
</script>

<style lang="scss" scoped>
.tool-result-message {
    display: flex;
    align-items: start;
    gap: 10px;

    &:hover :deep(.hover-bar) {
        opacity: 1;
        pointer-events: auto;
    }
}

.tool-result-message__body {
    p {
        color: var(--color-text-dark);
    }
}

.json-block {
    margin-top: 8px;
    padding: 10px 12px;
    background: var(--color-bg-dark, #1e1e2e);
    border: 1px solid var(--color-border);
    border-radius: 8px;
    font-family: 'JetBrains Mono', 'Fira Code', 'Courier New', monospace;
    font-size: 12px;
    line-height: 1.6;
    overflow-x: auto;
    white-space: pre;

    :deep(.json-key)    { color: #1565c0; }
    :deep(.json-string) { color: #2e7d32; }
    :deep(.json-number) { color: #c84b00; }
    :deep(.json-bool)   { color: #6a1b9a; }
    :deep(.json-null)   { color: #78909c; }
}
</style>
